import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import V2SettingsIframe from '@aware/common/v2-settings-iframe';
import { replaceCancelButtonAction } from './helpers';

const AssignFormToStudents = () => {
  const history = useHistory();
  const location = useLocation();

  const redirectFn = () => {
    history.push('assign-form-to-students');
  };

  return (
    <V2SettingsIframe
      iframeSrc="/aware/?embed=1&detailsSrc=/aware/manage/forms/massassign.aspx"
      title="Assign Form to Students"
      key={location.key}
      onLoadCallback={iframe => replaceCancelButtonAction({ iframe, redirectFn })}
    />
  );
};

export default AssignFormToStudents;
